var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30.573,
    viewBox: "0 0 24 30.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.36,584.7l-20.723-13.355c-1.229-.662-2.638-.593-2.638,1.784v26.3c0,2.173,1.511,2.515,2.638,1.784l20.723-13.355a2.264,2.264,0,0,0,0-3.155",
    transform: "translate(-419 -570.981)",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayWhite);
export default __webpack_public_path__ + "static/media/ic_play_white.226f59bb2d41e6fa53a993dfe307e368.svg";
export { ForwardRef as ReactComponent };